/* mapDataFormatters.js */

"use strict";
const _ = require("lodash");

function vendorFormatter(row, cell, value, columnDef, dataContext) {
    // console.log(columnDef, dataContext);
    const metaData = dataContext.metaData;
    return metaData && metaData.gluware && metaData.gluware.vendors
        ? metaData.gluware.vendors[value] || value
        : value;
}

function deviceTypeFormatter(row, cell, value, columnDef, dataContext) {
    const metaData = dataContext.metaData;
    return metaData && metaData.gluware && metaData.gluware.typeBases
        ? metaData.gluware.typeBases[value] || value
        : value;
}

function platformFormatter(row, cell, value, columnDef, dataContext) {
    const pfRegex = dataContext.pfRegex;
    const pfValue = dataContext.pfValue;
    if (dataContext.regex) {
        dataContext.platform = pfRegex;
    } else {
        dataContext.platform = pfValue;
    }
    return dataContext.platform;
}

function skuFormatter(row, cell, value, columnDef, dataContext) {
    const skuRegex = dataContext.skuRegex;
    const skuValue = dataContext.skuValue;
    if (dataContext.regex) {
        dataContext.sku = skuRegex;
    } else {
        dataContext.sku = skuValue;
    }
    return dataContext.sku;
}

function netboxRoleFormatter(row, cell, value, columnDef, dataContext) {
    const metaData = dataContext.metaData;
    const nbRoles =
        metaData && metaData.netbox && metaData.netbox.deviceRoles
            ? metaData.netbox.deviceRoles
            : [];
    const netBoxId = dataContext.netBoxId || "";
    const netBoxName = dataContext.netBoxName || "";
    const createMissing = dataContext.create;
    if (createMissing) {
        dataContext.netBoxDeviceRole = netBoxName;
        return netBoxName;
    } else {
        dataContext.netBoxDeviceRole = netBoxId;

        const nbRoleValue = nbRoles.find((val) => {
            if (val.id === netBoxId) {
                return true;
            }
            return false;
        });
        // console.log(nbRoleValue);

        return nbRoleValue ? nbRoleValue.display : netBoxId;
    }
}

function netboxManufacturerFormatter(row, cell, value, columnDef, dataContext) {
    const metaData = dataContext.metaData;
    const nbMfs =
        metaData && metaData.netbox && metaData.netbox.manufacturers
            ? metaData.netbox.manufacturers
            : [];
    const netBoxId = dataContext.netBoxId || "";
    const netBoxName = dataContext.netBoxName || "";
    const createMissing = dataContext.create;
    if (createMissing) {
        dataContext.netBoxDeviceManufaturer = netBoxName;
        return netBoxName;
    } else {
        dataContext.netBoxDeviceManufaturer = netBoxId;
        const nbMfsValue = nbMfs.find((val) => {
            if (val.id === netBoxId) {
                return true;
            }
            return false;
        });
        // console.log(nbMfsValue);

        return nbMfsValue ? nbMfsValue.display : netBoxId;
    }
}

function netboxPlatformFormatter(row, cell, value, columnDef, dataContext) {
    const metaData = dataContext.metaData;
    const nbPlatforms =
        metaData && metaData.netbox && metaData.netbox.platforms ? metaData.netbox.platforms : [];
    const netBoxId = dataContext.netBoxId || "";
    const netBoxName = dataContext.netBoxName || "";
    const createMissing = dataContext.create;
    if (createMissing) {
        dataContext.netBoxPlatform = netBoxName;
        return netBoxName;
    } else {
        dataContext.netBoxPlatform = netBoxId;
        const nbPlatformsValue = nbPlatforms.find((val) => {
            if (val.id === netBoxId) {
                return true;
            }
            return false;
        });
        // console.log(nbPlatformsValue);

        return nbPlatformsValue ? nbPlatformsValue.display : netBoxId;
    }
}

function netboxTypeFormatter(row, cell, value, columnDef, dataContext) {
    const metaData = dataContext.metaData;
    const nbTypes =
        metaData && metaData.netbox && metaData.netbox.deviceTypes
            ? metaData.netbox.deviceTypes
            : [];
    const netBoxId = dataContext.netBoxId || "";
    const netBoxName = dataContext.netBoxName || "";
    const createMissing = dataContext.create;
    if (createMissing) {
        dataContext.netBoxDeviceType = netBoxName;
        return netBoxName;
    } else {
        dataContext.netBoxDeviceType = netBoxId;
        const nbTypesValue = nbTypes.find((val) => {
            if (val.id === netBoxId) {
                return true;
            }
            return false;
        });
        // console.log(nbTypesValue);

        return nbTypesValue ? nbTypesValue.display : netBoxId;
    }
}

function deleteButtonFormatter(row, cell, value, columnDef, dataContext) {
    const button = document.createElement("base-icon-gl");
    button.dataset.icon = "common.trash_bin";
    button.setDarkTheme(false);

    button.setAttribute("aria-label", `delete ${dataContext.name}`);
    button.setAttribute("role", "button");

    button.dataset.uuid = dataContext.id;
    if (_.has(dataContext, "netBoxDeviceRole")) {
        button.dataset.action = "delete-role";
    } else if (_.has(dataContext, "netBoxDeviceType")) {
        button.dataset.action = "delete-type";
    } else if (_.has(dataContext, "netBoxDeviceManufaturer")) {
        button.dataset.action = "delete-manufacturer";
    } else if (_.has(dataContext, "netBoxPlatform")) {
        button.dataset.action = "delete-platform";
    } else {
        button.dataset.action = "delete";
    }

    return button.outerHTML;
}

function regexCheckboxFormatter(row, cell, value, columnDef, dataContext) {
    let checkbox = document.createElement("div");

    if (value) {
        checkbox = document.createElement("base-icon-gl");
        checkbox.dataset.icon = "common.check";
        checkbox.setDarkTheme(false);
        if (dataContext.isUnavailable) {
            checkbox.classList.add("disabled");
        }
    }
    return checkbox.outerHTML;
}

module.exports = {
    vendorFormatter,
    deviceTypeFormatter,
    netboxRoleFormatter,
    netboxManufacturerFormatter,
    netboxPlatformFormatter,
    netboxTypeFormatter,
    platformFormatter,
    skuFormatter,
    deleteButtonFormatter,
    regexCheckboxFormatter,
};
